Alerts = require 'views/lib/alerts'
ApiAjax = require 'network/api-ajax'
Dates = require 'lib/dates'
Format = require 'lib/markdown/format'
OrganizationView = require 'views/organization/organization-view'
Util = require 'lib/util'
_ = require 'underscore'
logError = require 'debug/log-error'
templates = require 'views/internal/templates'
track = require 'debug/track'
moment = require 'moment'
tryBabble = require 'lib/try-babble'
xtend = require 'xtend'

module.exports = class OrganizationExportView extends OrganizationView

  initialize: ->
    @listenTo @model,
      'change:exports', @renderExports

  events:
    'click .js-create-new-export': 'clickCreateNewExport'
    'click .js-download-export': 'downloadExport'

  renderMainContent: ->
    data = {}
    data.hasCSV = @model.isFeatureEnabled('csvExport')

    @$('.js-content').html(
      templates.fill(
        'org_export',
        data,
        { editable: @model.editable() }
      )
    )

    @renderExports()
    @setActiveView('.js-org-export')

    @

  renderExports: ->
    data = @model.toJSON({ prefs: true })
    $exports = @$('.js-list-exports').empty()

    if _.isEmpty(data.exports)
      html = templates.fill('org_export_empty')
    else
      html = ''
      for exp in data.exports
        data = _.clone(exp)
        data.size = Format.bytes(data.size)
        data.time = moment(Dates.parse(data.startedAt)).calendar()
        data.generating = !data.exportUrl?

        # Replace the stage key with its translation if we have one.
        stage = tryBabble(['exports', data.status.stage])
        if stage?
          data.status = xtend(data.status, { stage })
        else
          logError(new Error("Missing export stage for #{data.status.stage}"))

        html += templates.fill('org_export_item', data)

    $exports.append(html)

    @

  export: (attachments) ->
    ApiAjax
      url: "/1/organizations/#{ @model.get('name') }/exports"
      method: 'post'
      data:
        attachments: attachments
      success: (resp) =>
        track(
          "Organization",
          "Export",
          if attachments then 'With Attachments' else 'Without Attachments'
        )
        if resp?
          @model.get('exports').unshift(resp)
          @model.trigger('change:exports')
      error: (xhr, textStatus, err, defaultHandler) =>
        if xhr.responseText.indexOf('in progress') > -1
          Alerts.show('ongoing org export', 'error', 'alert', 5000)
        else
          defaultHandler()

  clickCreateNewExport: (e) ->
    Util.stop(e)

    if @$('#includeAttachments').is(':checked')
      @export(true)
    else
      @export(false)

  downloadExport: (e) ->
    track("Organization", "Download Export")
    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-export-view.coffee